import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Form,
    Button,
    Upload,
    Icon,
    Row,
    Col,
    Input
  } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'

class IDVerificationForm extends Component {
    handleSubmit() {
        return '';
    }

    render() {

        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <h1>ID Verification</h1>

                <Icon type="check-circle" theme="filled" style={{ color: 'green', fontSize: '40px' }} />
                <h3>Receive a verification badge on your profile to increase trust from other users</h3>
                <br/>
                <br/>
                <Form onSubmit={this.handleSubmit()}>
                    <Row>
                        <Col md={{ span: 16 }}>
                        <h3>1. Enter your name as it appears on your National ID</h3>
                            <Form.Item label="First Name">
                                {getFieldDecorator('firstName', {
                                    rules: [{ required: true, message: 'Please enter First Name' }],
                                })(
                                    <Input size="large" name="firstName" placeholder="First Name" />
                                )}

                            </Form.Item>

                            <Form.Item label="Last Name">
                                {getFieldDecorator('lastName', {
                                    rules: [{ required: true, message: 'Please enter Last Name' }],
                                })(
                                    <Input size="large" name="lastName" placeholder="Last Name" />
                                )}

                            </Form.Item>

                            <h3>2. Upload a photo of your National ID</h3>
                            <Form.Item >
                                {getFieldDecorator('dragger', {
                                    valuePropName: 'fileList',
                                    getValueFromEvent: this.normFile,
                                })(
                                    <Upload.Dragger name="files" action="/upload.do">
                                        <p className="ant-upload-drag-icon">
                                            <Icon type="inbox" />
                                        </p>
                                        <p className="ant-upload-text">Upload Photo of your National ID</p>
                                    </Upload.Dragger>,
                                )}
                            </Form.Item>


                            <Form.Item
                            >
                                <Button type="primary" htmlType="submit" style={{ height: '3em', marginRight: '10px', width: '100%', borderWidth: '0px' }}>
                                    Submit Verification
                            </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </div>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         isAuthenticated: state.token !== null
//     }
// }

const IDVerification = Form.create({ name: 'id-verification-form' })(IDVerificationForm);

// export default IDVerification;


export default connect(null, null)(IDVerification);

